module.exports = __webpack_public_path__ + "assets/images/264e70d15ba079c178675a36e437572f.png";